// extracted by mini-css-extract-plugin
export default {"card_container":"style_card_container__KkVIP"};